export default "__VITE_ASSET__BqrrpR_Z__"